"use client"

import VenueMenusClient from "./VenueMenusClient"
import { ENCAS_VENUE_CONFIG } from "../lib/venue-menus-client/venueMenusClientConfig"

const EncasClient = () => <VenueMenusClient config={ENCAS_VENUE_CONFIG} />

export default EncasClient
